import useStyles from './useStyles'
import {
  CircularProgress,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../../../../redux/actions/app'
import { createUserSystemDirectories } from '../../../../../../redux/actions/Storage'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logEvent } from '../../../../../../utils/LogEvents'
import { useEffect, useState } from 'react'

function TableItem ({ item }) {
  const classes = useStyles()

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const createUserDirectories = async (userId) => {
    // if (dataprocess?.data?.users && dataprocess?.data?.users.length > 0) {
    //   const userExists = dataprocess.data.users.find(
    //     (user) => user.userId === userId
    //   )

    // if (userExists) {

    const subId = item?.user?.suborganizationId
    const firmUser =
      item?.user?.user?.account?.firstName +
      ' ' +
      item?.user?.user?.account?.lastName
    const body = {
      suborganizationId: subId,
      firmUserId: userId,
      firmUserName: firmUser
    }

    try {
      const response = await dispatch(createUserSystemDirectories(body))

      if (response && response.status === 'success') {
        logEvent('CGI - createUserSystemDirectories', {
          body: { ...body },
          response: response
        })
        dispatch(setRequestTextSnackBar())
        dispatch(setSuccessTextSnackBar('Creación de carpeta exitosa'))
        setTimeout(() => {
          navigate(0)
        }, 2000)
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar('No se pudo crear la carpeta del usuario')
        )
      }
    } catch (error) {}
    // }
    // }
  }

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    } else {
      formattedDate = ''
    }
    return formattedDate
  }
  const getIconStatus = () => {
    const status = { value: null, title: '' }
    if (!item.directoryUser) {
      status.value = 'Failure'
      status.title = 'Fallo al buscar la carpeta'
    } else if (item.directoryUser) {
      if (item.directoryUser.exist === false) {
        status.value = 'Not found'
        status.title = 'No existe'
      } else if (item.directoryUser.exist === true) {
        if (item.directoryUser.directory[0].isDeleted) {
          status.value = 'Delete'
          status.title = 'Eliminado'
        } else if (item.directoryUser.directory[0].statusCode !== 'ACTIVE') {
          status.value = 'No active'
          status.title = item.directoryUser.directory[0].statusCode
        } else {
          status.value = 'Active'
          status.title = 'Activo'
        }
      }
    }
    switch (status.value) {
      case 'Active':
        return (
          <Tooltip title={status.title}>
            <IconButton>
              <CheckCircleIcon style={{ fontSize: '2rem', color: '#00a78f' }} />
            </IconButton>
          </Tooltip>
        )

      default:
        return (
          <>
            <div className={classes.buttons}>
              <Tooltip title={status.title}>
                <IconButton>
                  <CancelIcon style={{ fontSize: '2rem', color: '#AD0707' }} />
                </IconButton>
              </Tooltip>
              <ButtonConfirm
                userId={item.user.userId}
                createUserDirectories={createUserDirectories}
              />
            </div>
          </>
        )
    }
  }
  if (!item) return <div>Error</div>
  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemuser}>
          {item.user?.user?.account?.firstName +
            ' ' +
            item.user?.user?.account?.lastName}
        </td>
        <td className={classes.itemName}>
          {item.directoryUser?.directory[0].name}
        </td>
        <td className={classes.itemDate}>
          {formatDate(item.directoryUser?.directory[0].creationDate)}
        </td>
        <td className={classes.itemstatus}>{getIconStatus()}</td>
      </tr>
    </>
  )
}

export default TableItem

function ButtonConfirm ({
  showCircularProgress,
  isError,
  userId,
  createUserDirectories
}) {
  const [isProgressComplete, setProgressComplete] = useState(false)
  const classes = useStyles()
  const handleButtonClick = async () => {
    try {
      await createUserDirectories(userId)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (isError) {
      setProgressComplete(false)
    }
  })
  return (
    <div>
      <button
        className={classes.confirmButton}
        disabled={isProgressComplete && showCircularProgress}
        onClick={handleButtonClick}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography className={classes.confirmButtonTypography}>
            Crear Carpeta
          </Typography>
            )}
      </button>
    </div>
  )
}
